var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "list"
        ? _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { md: 24 } },
                [
                  _c(
                    "a-card",
                    { style: _vm.cardStyle, attrs: { bordered: false } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-operator",
                          staticStyle: { "margin-top": "5px" },
                        },
                        [
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", icon: "plus" },
                                  on: { click: _vm.handleAdd },
                                },
                                [_vm._v("新建页面")]
                              )
                            : _vm._e(),
                          _c("span", { staticClass: "decor-tip" }, [
                            _vm._v(
                              "同类型页面仅可发布一个；保存后需重新发布才对顾客端生效"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("a-table", {
                        ref: "table",
                        attrs: {
                          size: "middle",
                          bordered: "",
                          rowKey: "id",
                          columns: _vm.columns,
                          dataSource: _vm.dataSource,
                          pagination: false,
                          loading: _vm.loading,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "typeSlot",
                              fn: function (text) {
                                return [
                                  _c(
                                    "a-tag",
                                    {
                                      attrs: {
                                        color: _vm.typeMeta[text]
                                          ? _vm.typeMeta[text].color
                                          : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.typeMeta[text]
                                              ? _vm.typeMeta[text].label
                                              : text
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "statusSlot",
                              fn: function (text) {
                                return [
                                  text === "1"
                                    ? _c(
                                        "a-tag",
                                        { attrs: { color: "green" } },
                                        [_vm._v("已发布")]
                                      )
                                    : _c("a-tag", [_vm._v("未编辑")]),
                                ]
                              },
                            },
                            {
                              key: "action",
                              fn: function (text, record) {
                                return _c(
                                  "span",
                                  {},
                                  [
                                    _vm.btnEnableList.indexOf(1) > -1
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(record)
                                              },
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        )
                                      : _vm._e(),
                                    _vm.btnEnableList.indexOf(1) > -1
                                      ? [
                                          _c("a-divider", {
                                            attrs: { type: "vertical" },
                                          }),
                                          record.published === "1"
                                            ? _c(
                                                "a-popconfirm",
                                                {
                                                  attrs: {
                                                    title:
                                                      "撤回后顾客端将无法访问该页面，确定撤回吗？",
                                                  },
                                                  on: {
                                                    confirm: () =>
                                                      _vm.handleUnpublish(
                                                        record
                                                      ),
                                                  },
                                                },
                                                [_c("a", [_vm._v("撤回")])]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handlePublish(
                                                        record
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("发布")]
                                              ),
                                          _c("a-divider", {
                                            attrs: { type: "vertical" },
                                          }),
                                          _c(
                                            "a-popconfirm",
                                            {
                                              attrs: {
                                                title: "确定删除该页面吗？",
                                              },
                                              on: {
                                                confirm: () =>
                                                  _vm.handleDelete(record),
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          549515981
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.editingPage
        ? _c(
            "div",
            [
              _c("decor-editor", {
                attrs: { page: _vm.editingPage },
                on: { back: _vm.onEditorBack },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { ref: "container" },
        [
          _c(
            "a-modal",
            {
              staticStyle: { top: "200px" },
              attrs: {
                title: "新建装修页面",
                visible: _vm.addVisible,
                confirmLoading: _vm.addSaving,
                getContainer: () => _vm.$refs.container,
                mask: _vm.isDesktop(),
                maskClosable: false,
                cancelText: "取消",
                okText: "创建并编辑",
              },
              on: {
                ok: _vm.submitAdd,
                cancel: function ($event) {
                  _vm.addVisible = false
                },
              },
            },
            [
              _c(
                "a-form",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "页面类型",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: { placeholder: "请选择页面类型" },
                          model: {
                            value: _vm.addForm.pageType,
                            callback: function ($$v) {
                              _vm.$set(_vm.addForm, "pageType", $$v)
                            },
                            expression: "addForm.pageType",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "MALL_HOME" } },
                            [_vm._v("商城首页")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "DINING_HOME" } },
                            [_vm._v("点餐首页")]
                          ),
                          _c(
                            "a-select-option",
                            { attrs: { value: "CUSTOM" } },
                            [_vm._v("自定义")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "页面名称",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入页面名称",
                          "allow-clear": "",
                        },
                        model: {
                          value: _vm.addForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "name", $$v)
                          },
                          expression: "addForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }